import React, { Fragment } from "react";
import cx from "classnames";
import { getAllPropertyVerificationCount } from '../../store/actions/PropertyVerificationActions';
import { getAllProjectVerificationCount } from '../../store/actions/ProjectVerificationActions';
import { getAllServiceVerificationCount } from '../../store/actions/ServiceVerificationActions';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"; // Import withRouter HOC
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import HeaderLogo from "../AppLogo";
import SearchBox from "./Components/SearchBox";
import MegaMenu from "./Components/MegaMenu";
import UserBox from "./Components/UserBox";
import HeaderDots from "./Components/HeaderDots";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      propertyNotificationCount: 0,
      verifyTagCount: 0,
      projectNotificationCount: 0,
      pendingProjectCount: 0,
      serviceNotificationCount: 0,
    };
  }

  componentDidMount() {
    this.fetchProperties();
    this.fetchProject();
    this.fetchService();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.allPropertyVerificationCount !== this.props.allPropertyVerificationCount && this.props.allPropertyVerificationCount &&
      Array.isArray(this.props.allPropertyVerificationCount.data)
    ) {
      this.setState({ 
        propertyNotificationCount: this.props.allPropertyVerificationCount?.total || 0,
        verifyTagCount: this.props.allPropertyVerificationCount?.verifyTagCount?.length || 0,
      });
    }

    if (
      prevProps.allProjectVerificationCount !== this.props.allProjectVerificationCount && this.props.allProjectVerificationCount &&
      Array.isArray(this.props.allProjectVerificationCount.data)
    ) {
      this.setState({ 
        projectNotificationCount: this.props.allProjectVerificationCount?.total || 0,
        pendingProjectCount: this.props.allProjectVerificationCount?.pendingProjectCount?.length || 0,
      });
    }

    if (
      prevProps.allServiceVerificationCount !== this.props.allServiceVerificationCount && this.props.allServiceVerificationCount &&
      Array.isArray(this.props.allServiceVerificationCount.data)
    ) {
      this.setState({ 
        serviceNotificationCount: this.props.allServiceVerificationCount?.total || 0,
      });
    }
  }
  

  fetchProperties = (params = {}) => {
    const { page, limit, globalSearch } = this.state;
    this.props.getAllPropertyVerificationCount({ page, limit, search: globalSearch, ...params });
  };

  fetchProject = (params = {}) => {
    const { page, limit, globalSearch } = this.state;
    this.props.getAllProjectVerificationCount({ page, limit, search: globalSearch, ...params });
  };

  fetchService = (params = {}) => {
    const { page, limit, globalSearch } = this.state;
    this.props.getAllServiceVerificationCount({ page, limit, search: globalSearch, ...params });
  };

  handlePropertyNavigation = () => {
    this.props.history.push("/verification/propertyverification");
  };

  handleVerifyTagNavigation = () => {
    this.props.history.push("/verification/verifytag");
  };

  handleProjectNavigation = () => {
    this.props.history.push("/verification/projectverification");
  };

  handlePendingProjectNavigation = () => {
    this.props.history.push("/properties/project");
  };

  handleServiceNavigation = () => {
    this.props.history.push("/verification/serviceverification");
  };

  render() {
    let {
      headerBackgroundColor,
      enableMobileMenuSmall,
      enableHeaderShadow,
    } = this.props;
    const { propertyNotificationCount, verifyTagCount, projectNotificationCount, pendingProjectCount, serviceNotificationCount } = this.state;
    return (
      <Fragment>
        <style>
          {`
            .notification-icon-wrapper {
              position: relative;
              display: inline-block;
              margin-right: 15px;
            }

            .notification-icon-wrapper .btn-icon {
              background: transparent;
              border: none;
              cursor: pointer;
            }

            .notification-icon-wrapper i {
              font-size: 20px;
            }

            .notification-icon-wrapper span {
              position: absolute;
              top: -5px;
              right: -5px;
              background: red;
              color: white;
              border-radius: 50%;
              padding: 3px 7px;
              font-size: 12px;
              font-weight: bold;
            }

            .notification-icon-wrapper .hover-message {
              display: none;
              position: absolute;
              top: 30px;
              left: 50%;
              transform: translateX(-50%);
              background: black;
              color: white;
              padding: 5px 10px;
              border-radius: 5px;
              font-size: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-align: center;
              z-index: 1000; /* Ensure it appears above other elements */
              min-width: 150px; /* Prevent text from breaking outside the background */
              max-width: 200px; /* Limit the width of the tooltip */
              box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2); /* Add subtle shadow for better visibility */
            }

            .notification-icon-wrapper:hover .hover-message {
              display: block;
            }
          `}
        </style>
        <TransitionGroup>
          <CSSTransition component="div"
            className={cx("app-header", headerBackgroundColor, {
              "header-shadow": enableHeaderShadow,
            })}
            appear={true} timeout={1500} enter={false} exit={false}>
            <div>
              <HeaderLogo />
              <div className={cx("app-header__content", {
                  "header-mobile-open": enableMobileMenuSmall,
                })}>
                <div className="app-header-left">
                  {/* <SearchBox /> */}
                  {/* <MegaMenu /> */}
                </div>
                <div className="app-header-right">
                  <div
                    className="notification-icon-wrapper"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: "2px",
                    }}
                  >
                    <button
                      className="btn btn-icon" style={{ background: "transparent", border: "none", cursor: "pointer"}} onClick={this.handlePropertyNavigation}>
                      <i className="fa fa-home" style={{ fontSize: "20px" }}></i>
                    </button>
                    {propertyNotificationCount > 0 && (
                      <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "red", color: "white", borderRadius: "50%", padding: "3px 7px", fontSize: "12px", fontWeight: "bold" }}>
                        {propertyNotificationCount}
                      </span>
                    )}
                    <span className="hover-message">Pending Property Image</span>
                  </div>
                  <div
                    className="notification-icon-wrapper"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: "2px",
                    }}
                  >
                    <button
                      className="btn btn-icon" style={{ background: "transparent", border: "none", cursor: "pointer"}} onClick={this.handleVerifyTagNavigation}>
                      <i className="fa fa-check-double" style={{ fontSize: "20px" }}></i>
                    </button>
                    {verifyTagCount > 0 && (
                      <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "red", color: "white", borderRadius: "50%", padding: "3px 7px", fontSize: "12px", fontWeight: "bold" }}>
                        {verifyTagCount}
                      </span>
                    )}
                    <span className="hover-message">Verify Tags Pending</span>
                  </div>
                  <div
                    className="notification-icon-wrapper"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: "2px",
                    }}
                  >
                    <button
                      className="btn btn-icon" style={{ background: "transparent", border: "none", cursor: "pointer"}} onClick={this.handleProjectNavigation}>
                      <i className="fa fa-project-diagram" style={{ fontSize: "20px" }}></i>
                    </button>
                    {projectNotificationCount > 0 && (
                      <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "red", color: "white", borderRadius: "50%", padding: "3px 7px", fontSize: "12px", fontWeight: "bold" }}>
                        {projectNotificationCount}
                      </span>
                    )}
                    <span className="hover-message">Pending Project Image</span>
                  </div>
                  <div
                    className="notification-icon-wrapper"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: "2px",
                    }}
                  >
                    <button
                      className="btn btn-icon" style={{ background: "transparent", border: "none", cursor: "pointer"}} onClick={this.handlePendingProjectNavigation}>
                      <i className="fa fa-building" style={{ fontSize: "20px" }}></i>
                    </button>
                    {pendingProjectCount > 0 && (
                      <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "red", color: "white", borderRadius: "50%", padding: "3px 7px", fontSize: "12px", fontWeight: "bold" }}>
                        {pendingProjectCount}
                      </span>
                    )}
                    <span className="hover-message">Pending Project</span>
                  </div>
                  <div
                    className="notification-icon-wrapper"
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: "2px",
                    }}
                  >
                    <button
                      className="btn btn-icon" style={{ background: "transparent", border: "none", cursor: "pointer"}} onClick={this.handleServiceNavigation}>
                      <i className="fa fa-tools" style={{ fontSize: "20px" }}></i>
                    </button>
                    {serviceNotificationCount > 0 && (
                      <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "red", color: "white", borderRadius: "50%", padding: "3px 7px", fontSize: "12px", fontWeight: "bold" }}>
                        {serviceNotificationCount}
                      </span>
                    )}
                    <span className="hover-message">Pending Service Image</span>
                  </div>
                  <UserBox />
                </div>
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,

  allPropertyVerificationCount: state.PropertyVerificationReducer.allPropertyVerificationCount,
  allProjectVerificationCount: state.ProjectVerificationReducer.allProjectVerificationCount,
  allServiceVerificationCount: state.ServiceVerificationReducer.allServiceVerificationCount,
});

const mapDispatchToProps = (dispatch) => ({
  getAllPropertyVerificationCount: (params) => dispatch(getAllPropertyVerificationCount(params)),
  getAllProjectVerificationCount: (params) => dispatch(getAllProjectVerificationCount(params)),
  getAllServiceVerificationCount: (params) => dispatch(getAllServiceVerificationCount(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
